export default "__VITE_ASSET__CwiK8ID$__"